import { jsxs as p, jsx as t, Fragment as C } from "react/jsx-runtime";
import { useState as W, useEffect as V } from "react";
import { Box as e, Stack as v } from "@mui/material";
import { T as y } from "./Typography-HkIo7ajX.js";
import { h as X, c as E } from "./Slider-vVmtecg6.js";
import "@mui/material/Button";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { s as o } from "./spacings-C27fg6SF.js";
import "@mui/material/useAutocomplete";
import "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Box";
import "@mui/material/Typography";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/Chip";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
import { P as B } from "./PolicyAndTermsLinks-C0ktDBVB.js";
import { G as J, M as K } from "./MicrosoftIcon-BAfd0N_m.js";
import { L as Q } from "./Logo-agH5zvpp.js";
const w = 50, D = (r, i) => r.length > i ? `Email cannot be longer than ${i} characters` : "", Y = (r, i) => {
  if (!r)
    return "Field is required";
  const l = D(r, i);
  return l || (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(r) ? "" : "Enter a valid email");
}, G = ({
  onSubmit: r,
  buttonLabel: i,
  onEmailError: l,
  initialEmail: c = "",
  isButtonDisabled: x,
  maxEmailLength: h = w
}) => {
  const [a, u] = W(c), [m, d] = W(""), g = () => {
    u(c), d("");
  }, f = (s) => {
    const n = D(s, h);
    d(n ?? "");
  };
  return V(() => {
    m && l(m);
  }, [m, l]), /* @__PURE__ */ p(
    "form",
    {
      onSubmit: (s) => {
        s.preventDefault();
        const n = Y(a, h);
        if (n) {
          d(n);
          return;
        }
        r(a, g);
      },
      children: [
        /* @__PURE__ */ t(
          e,
          {
            sx: {
              "& .MuiInputBase-root": {
                height: "40px"
              }
            },
            children: /* @__PURE__ */ t(
              X,
              {
                value: a,
                onChange: (s) => {
                  const n = s.target.value;
                  u(n), f(n);
                },
                label: "Work email*",
                placeholder: "Enter your email",
                ...!!m && { errorText: m }
              }
            )
          }
        ),
        /* @__PURE__ */ t(e, { mt: o["3xl"] }),
        /* @__PURE__ */ t(
          E,
          {
            disabled: x || !a.trim() || !!m,
            size: "large",
            color: "primary",
            type: "submit",
            variant: "contained",
            fullWidth: !0,
            children: i
          }
        )
      ]
    }
  );
}, O = ({ title: r, subtitle: i = "" }) => /* @__PURE__ */ p(C, { children: [
  /* @__PURE__ */ t(
    e,
    {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      children: /* @__PURE__ */ t(
        y,
        {
          variant: "heading",
          size: "sm",
          align: "center",
          fontWeight: "semibold",
          color: "text.primary",
          children: r
        }
      )
    }
  ),
  !!i && /* @__PURE__ */ t(
    e,
    {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      mt: o.lg,
      children: /* @__PURE__ */ t(
        y,
        {
          variant: "text",
          align: "center",
          size: "md",
          color: "grey.600",
          children: i
        }
      )
    }
  )
] }), Z = ({
  onEmailError: r,
  buttonLabel: i,
  title: l,
  isButtonDisabled: c,
  subtitle: x = "",
  maxEmailLength: h = w,
  onSubmit: a,
  onAlternativeActionClick: u,
  alternativeText: m,
  alternativeActionLabel: d,
  privacyPolicyLink: g,
  termsLink: f
}) => /* @__PURE__ */ p(C, { children: [
  /* @__PURE__ */ t(
    O,
    {
      title: l,
      subtitle: x
    }
  ),
  /* @__PURE__ */ t(e, { mt: o["4xl"] }),
  /* @__PURE__ */ t(
    G,
    {
      isButtonDisabled: c,
      buttonLabel: i,
      maxEmailLength: h,
      onEmailError: r,
      onSubmit: (s, n) => {
        a({
          email: s,
          isSsoLogin: !0,
          resetForm: n
        });
      }
    }
  ),
  /* @__PURE__ */ t(e, { mt: o["4xl"] }),
  /* @__PURE__ */ t(
    B,
    {
      privacyPolicyLink: g,
      termsLink: f
    }
  ),
  /* @__PURE__ */ p(
    v,
    {
      direction: "row",
      justifyContent: "center",
      mt: o["3xl"],
      spacing: o.xs,
      children: [
        /* @__PURE__ */ t(
          e,
          {
            sx: { cursor: "pointer" },
            onClick: () => {
              u();
            },
            children: /* @__PURE__ */ t(
              y,
              {
                variant: "text",
                size: "sm",
                fontWeight: "semibold",
                color: "primary.700",
                children: d
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          y,
          {
            variant: "text",
            size: "sm",
            color: "grey.600",
            children: m
          }
        )
      ]
    }
  )
] }), tt = ({
  buttonlabel: r,
  initialEmail: i,
  shouldHideMagicLinkLogin: l,
  onSsoClick: c = () => {
  },
  onEmailError: x,
  onGoogleClick: h,
  onMicrosoftClick: a,
  title: u,
  alternativeText: m,
  onAlternativeActionClick: d,
  isButtonDisabled: g,
  alternativeActionLabel: f,
  subtitle: s = "",
  maxEmailLength: n = w,
  onSubmit: L,
  privacyPolicyLink: z,
  termsLink: A
}) => /* @__PURE__ */ p(C, { children: [
  /* @__PURE__ */ t(
    O,
    {
      title: u,
      subtitle: s
    }
  ),
  /* @__PURE__ */ t(e, { mt: o["4xl"] }),
  /* @__PURE__ */ t(
    E,
    {
      fullWidth: !0,
      variant: "outlined",
      color: "secondary",
      size: "large",
      startIcon: J,
      onClick: h,
      children: "Continue with Google"
    }
  ),
  /* @__PURE__ */ p(
    v,
    {
      direction: "row",
      spacing: o.xl,
      mt: o["4xl"],
      children: [
        /* @__PURE__ */ t(
          E,
          {
            fullWidth: !0,
            variant: "outlined",
            color: "secondary",
            size: "large",
            onClick: a,
            startIcon: K,
            children: "Microsoft"
          }
        ),
        /* @__PURE__ */ t(
          E,
          {
            fullWidth: !0,
            variant: "outlined",
            color: "secondary",
            size: "large",
            onClick: c,
            children: "SSO"
          }
        )
      ]
    }
  ),
  !l && /* @__PURE__ */ p(C, { children: [
    /* @__PURE__ */ p(
      v,
      {
        mt: o["3xl"],
        mb: o["4xl"],
        spacing: o.xl,
        direction: "row",
        alignItems: "center",
        children: [
          /* @__PURE__ */ t(
            e,
            {
              height: "1px",
              width: "100%",
              bgcolor: (b) => b.palette.grey[200]
            }
          ),
          /* @__PURE__ */ t(
            y,
            {
              variant: "text",
              size: "md",
              children: "OR"
            }
          ),
          /* @__PURE__ */ t(
            e,
            {
              height: "1px",
              width: "100%",
              bgcolor: (b) => b.palette.grey[200]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(
      G,
      {
        isButtonDisabled: g,
        buttonLabel: r,
        initialEmail: i,
        onEmailError: x,
        maxEmailLength: n,
        onSubmit: (b, k) => {
          L({
            email: b,
            resetForm: k
          });
        }
      }
    )
  ] }),
  /* @__PURE__ */ t(e, { mt: o["4xl"] }),
  /* @__PURE__ */ t(
    B,
    {
      privacyPolicyLink: z,
      termsLink: A
    }
  ),
  /* @__PURE__ */ p(
    v,
    {
      direction: "row",
      justifyContent: "center",
      mt: o["3xl"],
      spacing: o.xs,
      children: [
        /* @__PURE__ */ t(
          y,
          {
            variant: "text",
            size: "sm",
            color: "grey.600",
            children: m
          }
        ),
        /* @__PURE__ */ t(
          e,
          {
            sx: { cursor: "pointer" },
            onClick: () => {
              d();
            },
            children: /* @__PURE__ */ t(
              y,
              {
                variant: "text",
                size: "sm",
                fontWeight: "semibold",
                color: "primary.700",
                children: f
              }
            )
          }
        )
      ]
    }
  )
] }), Mr = ({
  privacyPolicyLink: r,
  termsLink: i,
  isLoading: l,
  ssoTitle: c,
  ssoSubtitle: x,
  signAlternativeActionLabel: h,
  ssoAlternativeText: a,
  ssoAlternativeActionLabel: u,
  onAlternativeLabelClick: m = () => {
  },
  subtitle: d,
  primaryButtonlabel: g,
  onEmailError: f = () => {
  },
  initialEmail: s = "",
  isLargeLogo: n = !0,
  title: L,
  alternativeText: z = "",
  shouldDisableMainButton: A,
  shouldShowLogo: b,
  shouldHideMagicLinkLogin: k = !1,
  maxWidth: R = 465,
  maxEmailLength: j = w,
  onMicrosoftClick: _,
  onGoogleClick: H,
  onSubmit: $
}) => {
  const [q, M] = W(!1), T = async ({ email: S, isSsoLogin: N, resetForm: P }) => {
    const I = S.trim(), U = I.substring(I.lastIndexOf("@") + 1);
    $({
      isSsoLogin: N,
      email: I,
      domain: U,
      resetForm: P
    });
  }, F = l || A;
  return /* @__PURE__ */ p(
    e,
    {
      maxWidth: R,
      width: "100%",
      children: [
        !!b && /* @__PURE__ */ t(
          e,
          {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: o["4xl"],
            children: /* @__PURE__ */ t(
              Q,
              {
                variant: "brand",
                type: "full",
                height: n ? 60 : 40
              }
            )
          }
        ),
        q ? /* @__PURE__ */ t(
          Z,
          {
            buttonLabel: g,
            title: c,
            onEmailError: (S) => {
              f({ description: S, isSsoLogin: !0 });
            },
            isButtonDisabled: F,
            subtitle: x,
            maxEmailLength: j,
            onSubmit: T,
            privacyPolicyLink: r,
            termsLink: i,
            alternativeText: a,
            onAlternativeActionClick: () => {
              M(!1);
            },
            alternativeActionLabel: u
          }
        ) : /* @__PURE__ */ t(
          tt,
          {
            title: L,
            privacyPolicyLink: r,
            shouldHideMagicLinkLogin: k,
            termsLink: i,
            onEmailError: (S) => {
              f({ description: S, isSsoLogin: !1 });
            },
            subtitle: d,
            isButtonDisabled: F,
            buttonlabel: g,
            initialEmail: s,
            alternativeText: z,
            alternativeActionLabel: h,
            maxEmailLength: j,
            onSubmit: T,
            onAlternativeActionClick: m,
            onSsoClick: () => {
              M(!0);
            },
            onGoogleClick: H,
            onMicrosoftClick: _
          }
        )
      ]
    }
  );
};
export {
  Mr as S
};
